import DropDownItem from "@/classes/component-classes/DropDownItem";

export default class Dimension {
    constructor(pieces = '', length = '', width = '', height = '', weight = '', packaging = '') {

        this.id = 0
        this.pieces = pieces
        this.length = length
        this.width = width
        this.height = height
        this.weight = weight
        this.packaging = packaging
    }
}
